// Build information, automatically generated by `ng-info`
const build = {
    version: "1.07.06",
    timestamp: "Thu Nov 27 2025 23:00:11 GMT-0600 (Central Standard Time)",
    message: null,
    git: {
        user: null,
        branch: "r1.07.06",
        hash: "fae44e",
        fullHash: "fae44eb1b05ca823237dfe8ad0fec30f828ac0a1"
    }
};

export default build;